import { render, staticRenderFns } from "./spbcnWinnerCamp.vue?vue&type=template&id=250da1f6&scoped=true&"
import script from "./spbcnWinnerCamp.vue?vue&type=script&lang=js&"
export * from "./spbcnWinnerCamp.vue?vue&type=script&lang=js&"
import style0 from "./spbcnWinnerCamp.vue?vue&type=style&index=0&id=250da1f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250da1f6",
  null
  
)

export default component.exports